import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseView, BaseText } from '@/components/base'
import { AppButton, Modal } from '@/components'
import { UpdateEmailMethodModalProps } from './types'
import { useNavigate } from 'react-router-dom'

export const UpdateEmailMethodModal: React.FC<UpdateEmailMethodModalProps> = ({
  isOpen,
  onClose,
  onReceiveCodeByPhone,
  onReceiveCodeByEmail,
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <Modal isOpen={isOpen} onClose={onClose} showHandle={true}>
      <BaseView
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 24,
          paddingTop: 16,
          paddingBottom: 34,
        }}
      >
        {/* Header */}
        <BaseView
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 16,
            paddingLeft: 16,
            paddingRight: 16,
          }}
        >
          {/* Title */}
          <BaseText
            fontSize={24}
            fontFamily="semibold"
            color="label.default"
            textAlign="center"
          >
            {/* {t('screens:editEmail.updateEmail')} */}
            Please contact support
          </BaseText>

          {/* Description */}
          <BaseText
            fontSize={16}
            fontFamily="regular"
            color="label.secondary"
            textAlign="center"
            style={{
              lineHeight: '22px',
            }}
          >
            {/* {t('screens:editEmail.chooseHowYouWantToGetCode')} */}
            To change your email, please contact support at
            support@kemkuwait.com
          </BaseText>
        </BaseView>

        {/* Action Buttons */}
        <BaseView
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: 12,
          }}
        >
          {/* <AppButton
            type="purpleGradientWithContour"
            label={t('screens:signinScreen.phoneNumber')}
            onPress={() => {
              onReceiveCodeByPhone()
              onClose()
            }}
            style={{ flex: 1 }}
          /> */}

          {/* <AppButton
            type="primaryGradient"
            label={t('form:actions.email')}
            onPress={() => {
              onReceiveCodeByEmail()
              onClose()
            }}
            style={{ flex: 1 }}
          /> */}
          <AppButton
            type="primaryGradient"
            label={'Contact support'}
            onPress={() => {
              navigate('mailto:support@kemkuwait.com')
            }}
          />
        </BaseView>
      </BaseView>
    </Modal>
  )
}
